import { ScopeOfPracticeEnum } from '@umss/shared/utils';

export interface UpdateGlobalDifferentialSettingsDto {
  rates: UpdateGlobalDifferentialRateItemDto[];
}

export interface UpdateGlobalDifferentialRateItemDto {
  scopeOfPractice: ScopeOfPracticeEnum;
  differentialRate: number;
  description?: string;
}

export interface GlobalDifferentialRatesResponseDto {
  rates?: GlobalDifferentialRateDto[];
  totalCount?: number;
}

export interface GlobalDifferentialRateDto {
  id: string;
  scopeOfPractice: ScopeOfPracticeEnum;
  scopeOfPracticeDisplay: string;
  differentialRate: number;
  description?: string;
  createdAt: string;
  updatedAt: string;
  scheduledRates: Partial<ScheduledDifferentialRateDto>[];
}

export interface ScheduledDifferentialRateDto {
  id: string;
  globalDifferentialRateId: string;
  differentialRate: number;
  effectiveFrom: string;
  effectiveTo: string;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateScheduledDifferentialRateDto {
  id?: string;
  differentialRate: number;
  effectiveFrom: string;
  effectiveTo: string;
  description?: string;
}

export interface ManageScheduledDifferentialRatesDto {
  scopeOfPractice: ScopeOfPracticeEnum;
  scheduledRates: UpdateScheduledDifferentialRateDto[];
}

export interface ScheduleDifferentialRatesResponseDto {
  scopeOfPractice: ScopeOfPracticeEnum;
  scopeOfPracticeDisplay: string;
  scheduledRates: Partial<ScheduledDifferentialRateDto>[];
  message: string;
}

export interface UpdateGlobalDifferentialRatesResponseDto {
  updatedRates?: GlobalDifferentialRateDto[];
  facilitiesAffected?: number;
  messages?: string;
}
